module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-02-06 at 12.53.22 AM.275f1e3b.jpeg";